import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { CONDITIONS } from "@/data/care";

// Map friendly name -> slug for linking (falls back to non-linked span).
const NAME_TO_SLUG = Object.fromEntries(CONDITIONS.map((c) => [c.name, c.slug]));

export default function ConditionsMarquee({ items }) {
  return (
    <div data-testid="conditions-marquee" className="border-y border-black/10 bg-bone py-8 md:py-10">
      <Marquee gradient={false} speed={30} pauseOnHover>
        {items.concat(items).map((c, i) => {
          const slug = NAME_TO_SLUG[c];
          const Inner = (
            <span className="font-serif italic text-3xl md:text-5xl tracking-tightest text-ink mx-10 md:mx-16 select-none hover:text-crimson transition-colors">
              {c}
              <span className="mx-6 md:mx-10 text-crimson not-italic">✦</span>
            </span>
          );
          return slug ? (
            <Link key={i} to={`/conditions/${slug}`} data-testid={`marquee-link-${slug}`}>{Inner}</Link>
          ) : (
            <span key={i}>{Inner}</span>
          );
        })}
      </Marquee>
    </div>
  );
}
